export const PANCHANG_TRANSLATIONS: Record<string, any> = {
    'English': {
        // Header
        vedicPanchang: "Vedic Panchang",
        panchangDesc: "Discover auspicious timings, planetary positions, and Hindu calendar information for any date and location.",

        // Control Panel
        selectDate: "Select Date",
        location: "Location",
        searchCity: "Search city...",
        loading: "Loading...",
        getPanchang: "Get Panchang",
        consultingStars: "Consulting the stars...",

        // Overview
        panchangOverview: "Panchang Overview",
        dateAndDay: "Date & Day",
        tithi: "Tithi",
        nakshatra: "Nakshatra",
        yoga: "Yoga",
        upto: "upto",

        // Sun & Moon
        sunMoonCalculations: "Sun & Moon Calculations",
        sunrise: "Sunrise",
        sunset: "Sunset",
        moonrise: "Moonrise",
        moonset: "Moonset",
        sunSign: "Sun Sign",
        moonSign: "Moon Sign",
        dayDuration: "Day Duration",
        ascendant: "Ascendant (Lagna)",
        udayaLagna: "Udaya Lagna",
        panchakaRahita: "Panchaka Rahita",
        bhadra: "Bhadra",
        active: "Active",
        inactive: "Inactive",
        varjyam: "Varjyam",
        amritKalam: "Amrit Kalam",
        vijayaMuhurta: "Vijaya Muhurta",
        madhyahna: "Madhyahna",
        ratrimana: "Ratrimana",
        sayahnaSandhya: "Sayahna Sandhya",
        specialYogas: "Special Yogas",
        dayChoghadiya: "Day Choghadiya",
        dinaShuddhi: "Dina Shuddhi",
        score: "Score",
        status: "Status",
        panchaka: "Panchaka",
        gandaMula: "Ganda Mula",
        pushyaYoga: "Pushya Yoga",
        guruPushya: "Guru Pushya",
        raviPushya: "Ravi Pushya",
        siddhiClass: "Siddhi-Class Yoga",
        availableWindows: "Available Windows",
        noRahitaWindow: "No Panchaka Rahita windows found for this cycle.",
        panchakaNotActive: "Panchaka is not active today — the entire day is Panchaka-free.",
        noSpecialWindow: "No special timing available for this date.",
        noDayChoghadiya: "No Choghadiya data available.",
        nextDay: "next day",
        excellent: "Excellent",
        good: "Good",
        average: "Average",
        caution: "Caution",
        mrityuPanchaka: "Mrityu Panchaka",
        agniPanchaka: "Agni Panchaka",
        rajaPanchaka: "Raja Panchaka",
        choraPanchaka: "Chora Panchaka",
        rogaPanchaka: "Roga Panchaka",

        // Hindu Calendar
        hinduCalendar: "Hindu Calendar",
        samvatsara: "Samvatsara",
        yearCycle: "60-Year Cycle",
        shakaSamvat: "Shaka Samvat",
        vikramSamvat: "Vikram Samvat",
        kaliSamvat: "Kali Samvat",
        monthPurnimanta: "Month (Purnimanta)",
        monthAmanta: "Month (Amanta)",
        pravishte: "Pravishte",

        // Festivals
        festivalsAndCelebrations: "Festivals & Celebrations",
        noFestivals: "No festivals or special celebrations for this date.",

        // Timings
        auspiciousTimings: "Auspicious Timings",
        inauspiciousTimings: "Inauspicious Timings",

        // Planetary Positions
        planetaryPositionsSunrise: "Planetary Positions at Sunrise",
        lagnaChart: "Lagna Chart",
        tableView: "Table View",
        northIndianStyle: "North Indian Style (Lagna Chart)",
        planet: "Planet",
        house: "House",
        rashi: "Rashi",
        degree: "Degree",
        pada: "Pada",

        // Additional Info
        additionalInfo: "Additional Info",
        ritu: "Ritu (Season)",
        karana: "Karana",
        dishaShoola: "Disha Shoola",

        // Tara & Chandra Bala
        taraChandraBala: "Tara & Chandra Bala",
        taraBala: "Tara Bala:",
        chandraBala: "Chandra Bala:",

        // Choghadiya labels
        amrit: "Amrit",
        shubh: "Shubh",
        labh: "Labh",
        chara: "Chara",
        udvega: "Udvega",
        roga: "Roga",
        kala: "Kala",
    },
    'Hindi': {
        // Header
        vedicPanchang: "वैदिक पंचांग",
        panchangDesc: "किसी भी तारीख और स्थान के लिए शुभ मुहूर्त, ग्रह स्थिति और हिंदू कैलेंडर की जानकारी खोजें।",

        // Control Panel
        selectDate: "तारीख चुनें",
        location: "स्थान",
        searchCity: "शहर खोजें...",
        loading: "लोड हो रहा है...",
        getPanchang: "पंचांग प्राप्त करें",
        consultingStars: "सितारों से परामर्श...",

        // Overview
        panchangOverview: "पंचांग अवलोकन",
        dateAndDay: "तारीख और दिन",
        tithi: "तिथि",
        nakshatra: "नक्षत्र",
        yoga: "योग",
        upto: "तक",

        // Sun & Moon
        sunMoonCalculations: "सूर्य और चंद्रमा की गणना",
        sunrise: "सूर्योदय",
        sunset: "सूर्यास्त",
        moonrise: "चंद्रोदय",
        moonset: "चंद्रास्त",
        sunSign: "सूर्य राशि",
        moonSign: "चंद्र राशि",
        dayDuration: "दिन की अवधि",
        ascendant: "लग्न",
        udayaLagna: "उदय लग्न",
        panchakaRahita: "पंचक रहित",
        bhadra: "भद्रा",
        active: "सक्रिय",
        inactive: "नहीं",
        varjyam: "वर्ज्यम",
        amritKalam: "अमृत काल",
        vijayaMuhurta: "विजय मुहूर्त",
        madhyahna: "मध्याह्न",
        ratrimana: "रात्रिमान",
        sayahnaSandhya: "सायं संध्या",
        specialYogas: "विशेष योग",
        dayChoghadiya: "दिवसीय चौघड़िया",
        dinaShuddhi: "दिन शुद्धि",
        score: "अंक",
        status: "स्थिति",
        panchaka: "पंचक",
        gandaMula: "गंड मूल",
        pushyaYoga: "पुष्य योग",
        guruPushya: "गुरु पुष्य",
        raviPushya: "रवि पुष्य",
        siddhiClass: "सिद्धि वर्ग योग",
        availableWindows: "उपलब्ध समय",
        noRahitaWindow: "इस चक्र में कोई पंचक रहित समय नहीं मिला।",
        panchakaNotActive: "आज पंचक सक्रिय नहीं है — पूरा दिन पंचक रहित है।",
        noSpecialWindow: "इस तिथि के लिए कोई विशेष समय उपलब्ध नहीं है।",
        noDayChoghadiya: "चौघड़िया डेटा उपलब्ध नहीं है।",
        nextDay: "अगले दिन",
        excellent: "उत्कृष्ट",
        good: "अच्छा",
        average: "सामान्य",
        caution: "सावधानी",
        mrityuPanchaka: "मृत्यु पंचक",
        agniPanchaka: "अग्नि पंचक",
        rajaPanchaka: "राज पंचक",
        choraPanchaka: "चोर पंचक",
        rogaPanchaka: "रोग पंचक",

        // Hindu Calendar
        hinduCalendar: "हिंदू कैलेंडर",
        samvatsara: "संवत्सर",
        yearCycle: "60 वर्ष चक्र",
        shakaSamvat: "शक संवत",
        vikramSamvat: "विक्रम संवत",
        kaliSamvat: "कलियुग संवत",
        monthPurnimanta: "माह (पूर्णिमांत)",
        monthAmanta: "माह (अमांत)",
        pravishte: "प्रविष्टे",

        // Festivals
        festivalsAndCelebrations: "त्योहार और उत्सव",
        noFestivals: "इस तिथि के लिए कोई त्योहार विशेष उत्सव नहीं है।",

        // Timings
        auspiciousTimings: "शुभ मुहूर्त",
        inauspiciousTimings: "अशुभ मुहूर्त",

        // Planetary Positions
        planetaryPositionsSunrise: "सूर्योदय के समय ग्रहों की स्थिति",
        lagnaChart: "लग्न चार्ट",
        tableView: "तालिका देखें",
        northIndianStyle: "उत्तर भारतीय शैली (लग्न चार्ट)",
        planet: "ग्रह",
        house: "भाव",
        rashi: "राशि",
        degree: "डिग्री",
        pada: "पद",

        // Additional Info
        additionalInfo: "अतिरिक्त जानकारी",
        ritu: "ऋतु (मौसम)",
        karana: "करण",
        dishaShoola: "दिशा शूल",

        // Tara & Chandra Bala
        taraChandraBala: "तारा और चंद्र बल",
        taraBala: "तारा बल:",
        chandraBala: "चंद्र बल:",

        // Choghadiya labels
        amrit: "अमृत",
        shubh: "शुभ",
        labh: "लाभ",
        chara: "चर",
        udvega: "उद्वेग",
        roga: "रोग",
        kala: "काल",
    }
};
